import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL + '/api/jabatan';

export const fetchJabatan = async () => {
  try {
    const res = await axios.get(API_BASE);
    return res.data.status ? res.data.data : [];
  } catch (err) {
    console.error('fetchJabatan error', err);
    return [];
  }
};

export const createJabatan = async (payload) => {
  const res = await axios.post(API_BASE, payload);
  return res.data;
};

export const updateJabatan = async (id, payload) => {
  const res = await axios.put(`${API_BASE}/${id}`, payload);
  return res.data;
};

export const deleteJabatan = async (id) => {
  const res = await axios.delete(`${API_BASE}/${id}`);
  return res.data;
};


export const getDropdownJabatan = async () => {
  try {
    const res = await axios.get(`${API_BASE}/drop/down/`);
    return res.data.status ? res.data.data : [];
  } catch (err) {
    console.error('fetchJabatan error', err);
    return [];
  }
};